// Module
var code = `<div id="loan-product-advanced">
  <form name="\$ctrl.form">
    <div class="form-section">
      <form-section form-title="'Loan information settings'">
        <div id="loan-account-information-defaults">
          <table class="table">
            <tbody class="tbody">
            <tr>
              <td class="label">Creation Type:</td>
              <td class="values">
                <select
                        ng-model="\$ctrl.loanProduct.defaultCreationType"
                        ng-options="entry.value as entry.label for entry in \$ctrl.creationTypes">
                        <option value=""> </option>
                </select>
              </td>
            </tr>

            <tr>
              <td class="label">Loan Class:</td>
              <td class="values">
                <select
                        ng-model="\$ctrl.loanProduct.defaultClassId"
                        ng-options="title.id as title.description for title in \$ctrl.dict.LOAN_CLASS">
                        <option value=""> </option>
                </select>
              </td>
            </tr>
            <tr>
              <td class="label">Loan Purpose:</td>
              <td class="values">
                <select
                        ng-model="\$ctrl.loanProduct.defaultPurposeId"
                        ng-options="title.id as title.description for title in \$ctrl.dict.LOAN_PURPOSE">
                        <option value=""> </option>
                </select>
              </td>
            </tr>
            <tr>
              <td class="label">Loan Security:</td>
              <td class="values">
                <select
                        ng-model="\$ctrl.loanProduct.defaultSecurityId"
                        ng-options="title.id as title.description for title in \$ctrl.loanSecurityOptions">
                  <option value=""> </option>
                </select>
              </td>
            </tr>
            <tr>
              <td class="label">Loan Economic Activity:</td>
              <td class="values">
                <select
                        ng-model="\$ctrl.loanProduct.defaultEconomicActivityId"
                        ng-options="title.id as title.description for title in \$ctrl.dict.LOAN_ECONOMIC_ACTIVITY">
                        <option value=""> </option>
                </select>
              </td>
            </tr>
            <tr>
              <td class="label">Microfinance Classification:</td>
              <td class="values">
                <select
                        ng-model="\$ctrl.loanProduct.defaultMicrofinanceClassificationId"
                        ng-options="title.id as title.description for title in \$ctrl.dict.LOAN_MICROFINANCE_CLASSIFICATION">
                        <option value=""> </option>
                </select>
              </td>
            </tr>
            <tr>
              <td class="label">Borrower Type:</td>
              <td class="values">
                <select
                        ng-model="\$ctrl.loanProduct.defaultLoanBorrowerTypeId"
                        ng-options="title.id as title.description for title in \$ctrl.dict.LOAN_BORROWER_TYPE">
                        <option value=""></option>
                </select>
              </td>
            </tr>
            <tr>
              <td class="label">Transaction Type:</td>
              <td class="values">
                <select
                        ng-model="\$ctrl.loanProduct.defaultLoanTransactionTypeId"
                        ng-options="title.id as title.description for title in \$ctrl.dict.LOAN_TRANSACTION_TYPE">
                        <option value=""> </option>
                </select>
              </td>
            </tr>
            <tr>
              <td class="label">CIC Contract Type:</td>
              <td class="values">
                <select
                        ng-model="\$ctrl.loanProduct.defaultCicContractType"
                        ng-options="item.value as item.label for item in \$ctrl.cicContractTypes">
                        <option value=""> </option>
                </select>
              </td>
            </tr>
            <tr>
              <td class="label mis-group">Loan Purpose to Industry:</td>
              <td class="values mis-group">
                <loan-industry-purpose
                  industry-purpose-id="\$ctrl.loanProduct.defaultLoanIndustryPurposeId">
                </loan-industry-purpose>
              </td>
            </tr>
            <tr>
              <td class="label mis-group">MIS Group:</td>
              <td class="values mis-group">
                <loan-mis-group mis-group-id="\$ctrl.loanProduct.defaultMisGroupId"></loan-mis-group>
              </td>
            </tr>
            <tr>
              <td class="label">Custom fields:</td>
              <td class="values">
                <custom-field-definition-multiselect
                  definition-ids="\$ctrl.loanProduct.productDefinition.customFieldDefinitionIds"
                  group="'LOAN'">
                </custom-field-definition-multiselect>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </form-section>
    </div>
    <div class="form-section">
      <form-section form-title="'Advanced'">
        <form-section-field field-title="'Metadata change mode'">
          <select
            ng-model="\$ctrl.loanProduct.manualMetadata"
            ng-options="o.value as o.label for o in [{ label: 'Automatic', value: false }, { label: 'Manual', value: true }]">
            required>
          </select>
        </form-section-field>
        <form-section-field field-title="'Allow backdating'">
          <select
            ng-model="\$ctrl.loanProduct.backdatingAllowed"
            boolean-options
            required>
          </select>
        </form-section-field>
        <form-section-field field-title="'Cure period'">
          <glue-container append="'days'">
            <input
              type="number"
              ng-model="\$ctrl.loanProduct.curePeriod"
              min="0"
              ng-max="\$ctrl.maxIntegerValue">
          </glue-container>
        </form-section-field>
        <form-section-field field-title="'Performance threshold'"
                            title="Number of days starting from the loan due date after which the loan is considered non-performing">
          <glue-container append="'days'">
            <input
              type="number"
              ng-model="\$ctrl.loanProduct.performanceThresholdDays"
              min="0"
              ng-max="\$ctrl.maxIntegerValue">
          </glue-container>
        </form-section-field>
        <form-section-field field-title="'Allow auto hand over'"
                            title="Whether loans of this type are handed over automatically to an external institution">
          <select
            ng-model="\$ctrl.loanProduct.allowHandover"
            boolean-options
            required>
          </select>
        </form-section-field>
        <form-section-field field-title="'Hand over grace period after maturity'"
                            title="Number of days after loan maturity before the loan is handed over"
                            ng-if="\$ctrl.loanProduct.allowHandover">
          <glue-container append="'days'">
            <input
              type="number"
              ng-model="\$ctrl.loanProduct.handoverGracePeriodAfterMaturity"
              min="0"
              ng-max="\$ctrl.maxIntegerValue"
              ng-required="\$ctrl.loanProduct.allowHandover">
          </glue-container>
        </form-section-field>
        <form-section-field field-title="'Hand over grace period after manual trigger'"
                            title="Number of days after a manual hand over trigger before the loan is handed over"
                            ng-if="\$ctrl.loanProduct.allowHandover">
          <glue-container append="'days'">
            <input
              type="number"
              ng-model="\$ctrl.loanProduct.handoverGracePeriodAfterManualTrigger"
              min="0"
              ng-max="\$ctrl.maxIntegerValue"
              ng-required="\$ctrl.loanProduct.allowHandover">
          </glue-container>
        </form-section-field>
      </form-section>
    </div>
  </form>
</div>


`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/loan/details/forms/loan-product-advanced.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;